import React from "react";
import "./Greeting.css";
// import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import BannerImg from "./BannerImg";
import Typewriter from "typewriter-effect";
import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
import { competitiveSites } from "../../portfolio";
export default function Greeting(props) {
  const theme = props.theme;
  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.orange }}>
                {greeting.title}
              </h1>
              <h1 className="greeting-sub" style={{ color: theme.grayText }}>
                I'm <mark data-entity="person">{greeting.sub}&nbsp;
                <i class="fas fa-user-graduate"></i>
                </mark>
              </h1>
              <h1 className="greeting-typewriter" style={{color: theme.blue}}>
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter
                      .typeString("Data Scientist (NLP) ")
                      .pauseFor(20)
                      .deleteAll()
                      .typeString("Tech Enthusiast")
                      .pauseFor(20)
                      .deleteAll()
                      .typeString("Software Developer")
                      .pauseFor(20)
                      .deleteAll()
                      .typeString("IT Engineer")
                      .pauseFor(20)
                      .deleteAll()
                      .typeString("FIDE Chess Player")
                      .pauseFor(100)
                      .deleteAll()
                      .start();
                  }}
                  options={{
                    autoStart: true,
                    loop: true,
                  }}
                />
              </h1>
              <span
                className="greeting-text-span subTitle"
                style={{ color: theme.text }}>
                <div className="entities">
                  A <mark data-entity="noun">Data Science practitioner&nbsp;
                  <i class="fas fa-diagnoses"></i>
                  </mark>{" "}
                  , an avid data enthusiast{" "}
                  <mark data-entity="verb">who delivers AI/ML based solutions&nbsp; 
                  <i class="fab fa-buffer"></i></mark>using
                  SOTA techniques along with {" "}
                  <mark data-entity="skill">Web Development &nbsp;<i class="fas fa-laptop-code"></i>
                  </mark>and blend of <mark data-entity="hobby">Chess mastery &nbsp;
                  <i class='fas fa-chess-king'></i>
                  </mark>
                </div>
              </span>
              <CompetitiveSites logos={competitiveSites.competitiveSites} />
              <div className="button-greeting-div">
                <Button text="Contact me" href="/contact" />
                <Button
                  text="See my resume"
                  newTab={true}
                  href={greeting.resumeLink}
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <BannerImg />
          </div>
        </div>
      </div>
    </Fade>
  );
}
